import {
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_ACCOUNT,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_ADD_TO_CART,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_CART,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_CATEGORY,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_DELIVERY_TRACKING,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_HOME_TOP,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_INACTIVITY_MODAL,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_NO_RESULT_PAGE,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_AVAILABLE,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_FIRST_IMPRESSION,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_RX,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_UNAVAILABLE,
  EXPERIMENT_NAME_RECOMMENDATION_SERVICE_REDPOINTS,
} from '../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../experiments/model/EXPERIMENT_VARIATION'
import { type ExperimentType } from '../../experiments/model/Experiment.types'
import {
  RECOMMENDATION_SERVICE_ACCOUNT,
  RECOMMENDATION_SERVICE_ADD_TO_CART,
  RECOMMENDATION_SERVICE_CART,
  RECOMMENDATION_SERVICE_CATEGORY,
  RECOMMENDATION_SERVICE_HOMEPAGE,
  RECOMMENDATION_SERVICE_INACTIVITY_MODAL,
  RECOMMENDATION_SERVICE_LP_DELIVERY_TRACKING,
  RECOMMENDATION_SERVICE_LP_REDPOINTS,
  RECOMMENDATION_SERVICE_NO_RESULT_PAGE,
  RECOMMENDATION_SERVICE_PDP_FIRST_IMPRESSION,
  RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE,
  RECOMMENDATION_SERVICE_PDP_PRODUCT_OUT_OF_STOCK,
  RECOMMENDATION_SERVICE_PDP_RX_PRODUCT,
  type RecommendationServiceType,
} from '../config/RecommendationServiceType'

export type RecommendationExperimentServiceIdConfig = {
  experimentName: ExperimentType['name']
  variants: EXPERIMENT_VARIATION[]
}

const EXPERIMENT_SERVICE_VARIANTS = [
  EXPERIMENT_VARIATION.V1,
  EXPERIMENT_VARIATION.V2,
]

const createExperimentServiceIdConfig = (
  experimentName: ExperimentType['name'],
): RecommendationExperimentServiceIdConfig => ({
  experimentName,
  variants: EXPERIMENT_SERVICE_VARIANTS,
})

export const recommendationExperimentServiceIdConfig: Partial<
  Record<RecommendationServiceType, RecommendationExperimentServiceIdConfig>
> = {
  [RECOMMENDATION_SERVICE_ACCOUNT]: createExperimentServiceIdConfig(
    EXPERIMENT_NAME_RECOMMENDATION_SERVICE_ACCOUNT,
  ),
  [RECOMMENDATION_SERVICE_ADD_TO_CART]: createExperimentServiceIdConfig(
    EXPERIMENT_NAME_RECOMMENDATION_SERVICE_ADD_TO_CART,
  ),
  [RECOMMENDATION_SERVICE_CART]: createExperimentServiceIdConfig(
    EXPERIMENT_NAME_RECOMMENDATION_SERVICE_CART,
  ),
  [RECOMMENDATION_SERVICE_CATEGORY]: createExperimentServiceIdConfig(
    EXPERIMENT_NAME_RECOMMENDATION_SERVICE_CATEGORY,
  ),
  [RECOMMENDATION_SERVICE_HOMEPAGE]: createExperimentServiceIdConfig(
    EXPERIMENT_NAME_RECOMMENDATION_SERVICE_HOME_TOP,
  ),
  [RECOMMENDATION_SERVICE_INACTIVITY_MODAL]: createExperimentServiceIdConfig(
    EXPERIMENT_NAME_RECOMMENDATION_SERVICE_INACTIVITY_MODAL,
  ),
  [RECOMMENDATION_SERVICE_LP_DELIVERY_TRACKING]:
    createExperimentServiceIdConfig(
      EXPERIMENT_NAME_RECOMMENDATION_SERVICE_DELIVERY_TRACKING,
    ),
  [RECOMMENDATION_SERVICE_LP_REDPOINTS]: createExperimentServiceIdConfig(
    EXPERIMENT_NAME_RECOMMENDATION_SERVICE_REDPOINTS,
  ),
  [RECOMMENDATION_SERVICE_NO_RESULT_PAGE]: createExperimentServiceIdConfig(
    EXPERIMENT_NAME_RECOMMENDATION_SERVICE_NO_RESULT_PAGE,
  ),
  [RECOMMENDATION_SERVICE_PDP_FIRST_IMPRESSION]:
    createExperimentServiceIdConfig(
      EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_FIRST_IMPRESSION,
    ),
  [RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE]:
    createExperimentServiceIdConfig(
      EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_AVAILABLE,
    ),
  [RECOMMENDATION_SERVICE_PDP_PRODUCT_OUT_OF_STOCK]:
    createExperimentServiceIdConfig(
      EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_UNAVAILABLE,
    ),
  [RECOMMENDATION_SERVICE_PDP_RX_PRODUCT]: createExperimentServiceIdConfig(
    EXPERIMENT_NAME_RECOMMENDATION_SERVICE_PDP_RX,
  ),
}
